export function convertCurrency(value, fromCurrency, toCurrency, rates) {
  const amount = Number(value) || 0
  if (fromCurrency === toCurrency) return amount
  const fromRate = Number(rates?.[fromCurrency])
  const toRate = Number(rates?.[toCurrency])
  if (!fromRate || !toRate) return null
  return amount / fromRate * toRate
}

export function sumInCurrency(items, targetCurrency, rates, getValue = item => item.value, getCurrency = item => item.currency) {
  return items.reduce((total, item) => {
    if (total === null) return null
    const converted = convertCurrency(getValue(item), getCurrency(item) || 'GBP', targetCurrency, rates)
    return converted === null ? null : total + converted
  }, 0)
}

